<mat-form-field class="block w-full mat-form-field-no-padding" floatLabel="always">
  <mat-label>{{ 'settings.theme' | translate }}</mat-label>
  <mat-select [value]="colorScheme()" (selectionChange)="setTheme($event)">
    @for (group of colorSchemeGroupList | KeyValue; track $index) {
      <mat-optgroup [label]="group.value.name" class="theme-group">
        @for (entry of group.value.entries; track $index) {
          <mat-option [value]="entry">{{ colorSchemeData[entry].name }}</mat-option>
        }
      </mat-optgroup>
    }
  </mat-select>
</mat-form-field>
<p class="setting-description">{{ 'settings.themeDescription' | translate }}</p>
<mat-form-field class="block w-full mat-form-field-no-padding" floatLabel="always">
  <mat-label>{{ 'settings.lightDarkMode' | translate }}</mat-label>
  <mat-select [value]="lightDarkMode()" (selectionChange)="setLightDarkMode($event)">
    @for (entry of colorThemeData | KeyValue; track $index) {
      <mat-option [value]="entry.key">{{ entry.value }}</mat-option>
    }
  </mat-select>
</mat-form-field>
<p class="setting-description">{{ 'settings.lightDarkModeDescription' | translate }}</p>
<mat-form-field class="block w-full mat-form-field-no-padding" floatLabel="always">
  <mat-label>{{ 'settings.additionalStyleModes' | translate }}</mat-label>
  <mat-select [(value)]="additionalStyleModesSelect" (selectionChange)="setAdditionalStyleModes($event)" multiple>
    @for (entry of additionalStyleModesData | KeyValue; track $index) {
      <mat-option [value]="entry.key">{{ entry.value.name }}</mat-option>
    }
  </mat-select>
</mat-form-field>
<p class="setting-description">{{ 'settings.additionalStyleModesDescription' | translate }}</p>
